<template>
  <v-skeleton-loader
    v-if="isCartLoading"
    class="price-summary__skeleton"
    type="text@2, divider, heading" />
  <div v-else class="price-summary">
    <div class="d-flex justify-space-between">
      <p class="calculator-label">{{ $t('purchaseV2.basket.price') }}</p>
      <p class="calculator-value">
        {{ formattedPrice }} {{ arenaCurrencySymbol }}
      </p>
    </div>
    <div class="d-flex justify-space-between">
      <p class="calculator-label">{{ $t('purchaseV2.basket.discount') }}</p>
      <p class="calculator-value">
        {{ discountAmount }} {{ arenaCurrencySymbol }}
      </p>
    </div>
    <v-divider class="divider" />
    <div class="d-flex justify-space-between align-center">
      <p class="total-label">{{ $t('purchaseV2.basket.total') }}</p>
      <p class="total-value">{{ formattedTotal }} {{ arenaCurrencySymbol }}</p>
    </div>
  </div>
</template>

<script>
import { formatPrice } from '@/utils/price'

export default {
  name: 'BasketPriceSummary',
  props: {
    arenaCurrency: { type: Object, default: () => ({}) },
    discount: { type: Number, default: 0 },
    isCartLoading: { type: Boolean, default: false },
    price: { type: Number, default: 0 },
    total: { type: Number, default: 0 },
  },
  computed: {
    arenaCurrencySymbol() {
      if (!this.arenaCurrency) return ''
      return this.arenaCurrency?.symbol || this.arenaCurrency?.code || ''
    },
    formattedPrice() {
      return formatPrice(this.price)
    },
    formattedTotal() {
      return formatPrice(this.total)
    },
    discountAmount() {
      const discountAmount = Number(this.total) - Number(this.price)
      return formatPrice(discountAmount)
    },
  },
}
</script>

<style scoped>
.price-summary {
  width: 100%;
  position: relative;

  --price-summary-label-color: var(--v-primary-text-base);
  --price-summary-value-color: var(--v-primary-text-darken4);
}

.price-summary__loader {
  position: absolute;
  inset: 0;
  display: flex;
  justify-content: center;
  align-items: center;
  background: rgba(255, 255, 255, 0.6);
  z-index: 1;
}

.price-summary__skeleton {
  width: 100%;
}

.price-summary__skeleton ::v-deep .v-skeleton-loader__divider {
  margin: 0.625rem 0 0.625rem;
}

.price-summary__skeleton ::v-deep .v-skeleton-loader__text {
  height: 24px;
}

.price-summary__skeleton ::v-deep .v-skeleton-loader__heading {
  height: 36px;
}

.calculator-label {
  margin-bottom: 0.625rem;
  font-weight: 600;
  color: var(--price-summary-label-color);
}

.calculator-value {
  margin-bottom: 0.625rem;
  font-weight: 700;
  color: var(--price-summary-value-color);
}

.divider {
  border-width: 1px;
  border-color: var(--v-primary-base) !important;
}

.total-label {
  margin-bottom: 0;
  font-weight: 600;
  font-size: 1.5rem;
  color: var(--price-summary-label-color);
}

.total-value {
  margin-bottom: 0;
  font-weight: 700;
  font-size: 2rem;
  color: var(--v-primary-base);
}
</style>
